const en = {
  nav: {
    features: "Features",
    pricing: "Pricing",
    blog: "Blog",
    about: "About Us",
    guides: "Guides",
    guide1: "Link in Bio for Creators",
    guide2: "Link in Bio for Instagram",
    guide3: "Monetize Instagram",
    guide4: "Sell Digital Products",
    guide5: "Free Link in Bio",
    guide6: "Online Bookings",
    dashboard: "Dashboard",
    logout: "Logout",
    login: "Log in",
    register: "Sign up free",
  },
  hero: {
    badge: "The conversion platform for creators",
    title1: "The link‑in‑bio that ",
    titleHighlight: "turns followers into customers",
    desc: "A <strong>link in bio</strong> that really sells: products, <strong>bookings</strong> and analytics on one page. <strong>Deeplink™</strong> opens your links in the real browser instead of the social in-app one, so payments and bookings complete. Plus, <strong>we pay you for every click received</strong>.",
    cta: "Create your link that sells",
    ctaHint: "7-day PRO trial included",
    subCta: "No credit card · 1-minute setup · Cancel anytime",
    imgAlt: "TuttiIMieiLink app mockup",
    socialProof: "600+ creators · 4.9/5",
    stickyCta: "Start for free",
    stickyCtaVariantB: "Create your link that sells",
    stickyCtaVariantC: "Try it free for 7 days →",
    stickyCtaVariantD: "Start now — it's free",
    statCreators: "active creators",
    statClicks: "monetized clicks",
    statRating: "out of 5 stars",
    demoBadge: "Live demo",
    demoCaption: "See how a click turns into a sale",
    demoSaleLabel: "+€12 sale",
    demoLinkLabel: "My new course",
  },
  problem: {
    badge: "The problem",
    title1: "Most link‑in‑bio tools are just a ",
    titleMuted: "list of links",
    desc: "You get thousands of clicks from social media but don't convert them into customers. Traffic is there, sales are not.",
    items: [
      "Traffic arrives but nobody buys",
      "Your analytics show clicks, not conversions",
      "The in-app browser blocks checkouts and signups",
    ],
  },
  solution: {
    badge: "The solution",
    title1: "Turn your link into a ",
    titleHighlight: "sales funnel",
    desc: "Not another link‑in‑bio. A complete system to convert followers into paying customers.",
    items: [
      { title: "Custom Landing Page", desc: "A simple editor to create pages that convert, not just lists of links." },
      { title: "Sell Digital Products", desc: "Sell ebooks, courses, templates and consultations directly from your page." },
      { title: "Email & Lead Collection", desc: "Built-in forms and lead magnets to grow your list and sell more." },
      { title: "Conversion Analytics", desc: "Not just clicks: measure CTR, conversions and revenue generated by each link." },
    ],
  },
  howItWorks: {
    title: "From follower to customer in 3 steps",
    subtitle: "Quick setup, immediate results",
    steps: [
      { title: "Create your page", desc: "Sign up for free and customize your landing page with our simple and fast editor." },
      { title: "Add links or products", desc: "Add your sales links, digital products, contact forms and lead magnets." },
      { title: "Turn clicks into customers", desc: "Deeplink™ and conversion analytics show you what works. Optimize and scale your revenue." },
    ],
  },
  features: {
    badge: "Key Features",
    title: "Everything you need to convert",
    desc: "Every feature is designed to turn social traffic into paying customers.",
    uniqueBadge: "ONLY PLATFORM",
    items: [
      { title: "Earn per click", desc: "We're the only platform that pays you for clicks received. Up to €0.01 per click: the more traffic you bring, the more you earn. No one else does this." },
      { title: "Smart Landing Page", desc: "A block editor to create conversion pages: buttons, videos, images, countdowns and testimonials. All optimized to sell." },
      { title: "Lead Capture", desc: "Built-in forms to collect emails and contacts. Add lead magnets to grow your list and sell more." },
      { title: "Deeplink™", desc: "Social links open in the in-app browser and block checkouts. Our technology forces opening in the real browser: +40% conversions." },
      { title: "Shield Protection™", desc: "Filters bots and suspicious clicks in real time. You only pay for real visitors who buy." },
      { title: "Geo Filter", desc: "Show different offers based on visitor's country. Localized pricing and redirects for regional stores." },
      { title: "Conversion Analytics", desc: "Not just clicks: measure CTR, conversions and revenue. Find your best-performing links and optimize your strategy." },
    ],
  },
  comparison: {
    badge: "Honest comparison",
    title: "Why aren't you on Linktree?",
    desc: "Linktree is a great start. But if you want to <strong>sell</strong>, you need different tools.",
    featureCol: "Feature",
    rows: [
      "Earn money on every click received",
      "Built-in digital product sales",
      "Physical product sales with shipping",
      "Deeplink™ (opens in real browser)",
      "Shield Protection™ anti-bot",
      "Geo Filter for localized offers",
      "Conversion analytics",
      "Customizable landing page",
      "Custom domain",
      "+40% checkout conversions",
      "Multi-link with sales tracking",
    ],
  },
  smartLinks: {
    badge: "Smart Automation",
    title: "Links that adapt to your audience",
    desc: "Your links automatically change based on the visitor's device, time of day, and country. Zero configuration, maximum conversions.",
    autoLabel: "100% automatic ✨",
    bottomHighlight: "No competitor offers automatic smart links. Only TuttiIMieiLink.",
    rules: [
      {
        icon: "device",
        title: "Smart Device Detection",
        desc: "Show different links to iPhone vs Android users. Automatically send to the right App Store or optimized mobile version.",
        example: "📱 Download on App Store",
      },
      {
        icon: "time",
        title: "Time of Day",
        desc: "Show different offers based on time: flash sales in the evening, educational content in the morning. Your funnel works 24/7.",
        example: "🌙 Evening deal -30%",
      },
      {
        icon: "geo",
        title: "Visitor's Country",
        desc: "Automatically localized offers: prices in local currency, links to regional stores, content in the visitor's language.",
        example: "🇩🇪 Shop Deutschland",
      },
    ],
  },
  socialLogos: {
    title: "Integrated with the platforms you love",
  },
  creatorCarousel: {
    title: "Creators selling with TuttiIMieiLink",
    desc: "Join thousands of creators monetizing their audience every day",
  },
  stats: {
    badge: "Results speak",
    title: "Not vanity metrics. Real sales.",
    items: [
      { value: "+40%", label: "Conversions", desc: "Average conversion increase thanks to Deeplink™ that opens links in the real browser." },
      { value: "600+", label: "Active creators", desc: "Creators already using TuttiIMieiLink to monetize their audience." },
      { value: "700+", label: "Clicks tracked", desc: "Real clicks tracked and optimized through the platform, growing every day." },
    ],
  },
  testimonial: {
    badge: "Testimonials",
    title: "Creators who sell more",
    desc: "Don't just take our word for it. Here's what creators using TuttiIMieiLink every day say.",
    items: [
      { quote: "Since using TuttiIMieiLink, my course sales from Instagram have increased by 60%. Deeplink™ makes all the difference.", name: "Luca M.", role: "Creator & Digital Entrepreneur", metric: "+60% sales" },
      { quote: "I tried Linktree, Beacons and others. With TuttiIMieiLink the conversion rate is double. Shield Protection saved me from thousands of bot clicks.", name: "Chiara R.", role: "Fashion Influencer · 120K followers", metric: "2x conversions" },
      { quote: "Geo Filter is amazing: I show different offers to people in Italy vs abroad. Competitors don't have it. 5 min setup.", name: "Marco B.", role: "E-commerce Owner", metric: "+40% CTR" },
      { quote: "Finally a platform designed to sell, not just list links. Conversion analytics tell me exactly what works.", name: "Sara T.", role: "Coach & Consultant", metric: "3x ROI" },
      { quote: "My audience is 80% mobile from Instagram. Before, half the clicks died in the in-app browser, now with Deeplink™ they all reach the real site.", name: "Davide P.", role: "YouTuber & Podcaster", metric: "-50% bounce" },
      { quote: "I migrated everything in one afternoon. The interface is super simple and support responds quickly. Never going back.", name: "Elena F.", role: "Food Blogger", metric: "5 min setup" },
      { quote: "I use TuttiIMieiLink to sell my Lightroom presets. Since I activated pay-per-click I even earn from visitors who don't buy. Genius.", name: "Giulia V.", role: "Photographer & Content Creator", metric: "+€200/month" },
      { quote: "I manage 5 creators with the Agency plan. Having everything in one panel with global analytics saves me hours every week.", name: "Andrea C.", role: "Social Media Manager", metric: "5 creators, 1 panel" },
      { quote: "My students click the link in bio and go straight to checkout without blocks. Enrollments in my courses have doubled.", name: "Federica L.", role: "Online Yoga Instructor", metric: "+100% enrollments" },
      { quote: "I started with the Free plan to test. After one week I upgraded to Creator because the results were too good not to invest.", name: "Tommaso G.", role: "Independent Musician", metric: "Free → Creator in 7d" },
    ],
  },
  pricing: {
    badge: "Invest in your sales",
    title: "How much is a buying follower worth?",
    desc: "Choose the plan that grows your revenue.",
    annual: "Annual -20%",
    monthly: "Monthly",
    earningsBanner: "The only platform that pays you for every click received",
    socialProof: "Already <strong>1,000+</strong> creators use TuttiMieiLink",
    mostPopular: "Most popular",
    saveAnnual: "Save 20% with the annual plan.",
    loading: "Loading...",
    plans: [
      {
        name: "Free",
        desc: "Try the platform with basic features. When you want to grow, upgrade to Starter.",
        links: "Up to 10 links",
        cta: "Start for free",
        features: ["1 page", "Up to 10 links", "Deeplink™ Technology", "Shield Protection™", "Basic Analytics (views & clicks)", "Tip Jar — receive donations", "Customizable themes & fonts", "Earn €0.005 per click"],
      },
      {
        name: "Starter",
        desc: "Unlimited links, up to 3 products and 7-day analytics. Perfect to start selling.",
        links: "Unlimited links",
        cta: "Try free for 7 days",
        features: [
          "Everything in Free, plus:",
          "Unlimited links",
          "Up to 3 digital products",
          "7-day analytics",
          "Discount codes",
          "Custom Tip Jar",
          "Premium themes",
          "Earn €0.005 per click",
        ],
      },
      {
        name: "Creator",
        desc: "Advanced analytics, lead capture and product sales to maximize every conversion.",
        links: "Unlimited links",
        cta: "Try free for 7 days",
        features: [
          "Everything in Starter, plus:",
          "Unlimited products",
          "1 Custom Domain",
          "Conversion & CTR Analytics",
          "Lead Capture & email forms",
          "Physical products with shipping",
          "Product bundles",
          "Memberships & subscribers",
          "Testimonials",
          "Real-time Social Proof",
          "Smart Bio by traffic source",
          "Smart Links with scheduling",
          "Creator Score",
          "A/B Test link position",
          "Meta, TikTok & GA Pixels",
          "Email automations",
          "Earn €0.01 per click (2x)",
        ],
      },
      {
        name: "Agency",
        desc: "Manage multiple creators, multiple funnels and advanced dashboard from one panel.",
        links: "Unlimited links",
        cta: "Try free for 7 days",
        features: [
          "Everything in Creator, plus:",
          "2 Custom Domains",
          "Multi-creator management",
          "Creator collaborations",
          "AI-powered multiple funnels",
          "Global analytics dashboard",
          "Contact & lead CRM",
          "CSV product import",
          "Referral program",
          "Earn €0.01 per click (2x)",
        ],
      },
    ],
    miniTestimonials: [
      { quote: "Since switching to TuttiMieiLink my sales increased by 35%. The express checkout is a game changer!", name: "Giulia R.", role: "Content Creator" },
      { quote: "Finally a platform that pays me for clicks. I already earned €120 in one month.", name: "Marco T.", role: "Influencer" },
      { quote: "I used Linktree for 2 years. With TuttiMieiLink my followers actually buy.", name: "Sara M.", role: "Fashion Blogger" },
    ],
  },
  faq: {
    badge: "FAQ",
    title: "Frequently Asked Questions",
    items: [
      { q: "How does TuttiIMieiLink help me sell more?", a: "Deeplink™ technology forces your links to open in the real browser, bypassing the in-app browser that blocks checkouts and payments. Result: +40% average conversions on purchases and signups." },
      { q: "What's the difference compared to Linktree or other link-in-bio tools?", a: "Others give you a list of links. We give you a sales system: Deeplink™ for conversions, Shield Protection™ against fake traffic, Geo Filter for localized offers and analytics focused on conversions, not vanity metrics." },
      { q: "Can I use it to sell courses, merch, consultations?", a: "Absolutely. Any sales link — Gumroad, Shopify, Teachable, Calendly, Ko-fi — works better with Deeplink™. Your followers reach checkout without blocks." },
      { q: "How does Shield Protection™ work?", a: "Shield analyzes traffic in real time and filters bots, suspicious clicks and fake visits. So your analytics show only real visitors and your ad budget isn't wasted." },
      { q: "Can I connect a custom domain?", a: "Yes! With the Creator plan or higher you can connect your domain for a more professional look and increase trust with your potential customers." },
    ],
  },
  ctaFooter: {
    title: "Stop losing sales from your bio link",
    desc: "Every day you spend with a generic link-in-bio, you lose customers. Deeplink™, Shield and conversion analytics: all free to start.",
    cta: "Start for free",
    brandDesc: "The link-in-bio that helps creators sell.",
    copyright: "© {{year}} TuttiIMieiLink. All rights reserved.",
    footerSections: {
      product: "Product",
      resources: "Resources",
      company: "Company",
      legal: "Legal",
    },
    footerLinks: {
      features: "Features",
      pricing: "Pricing",
      guide1: "Link in Bio for Creators",
      guide2: "Link in Bio for Instagram",
      guide3: "Monetize Instagram",
      guide4: "Sell Digital Products",
      about: "About Us",
      contact: "Contact",
      terms: "Terms of Use",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
    },
  },
  scrollingTags: ["Sell Online Courses", "Merch & E-commerce", "Consulting", "Affiliations", "Digital Products", "Coaching"],
  auth: {
    back: "Back to home",
    loginTitle: "Log in to your account",
    loginSubtitle: "Welcome back! Sign in to manage your page",
    registerTitle: "Create a new account",
    continueGoogle: "Continue with Google",
    continueApple: "Continue with Apple",
    or: "or",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    login: "Log In",
    register: "Sign Up",
    loading: "Loading...",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    forgotDesc: "Enter your email to receive the reset link",
    sendReset: "Send reset link",
    sending: "Sending...",
    backToLogin: "Back to login",
    checkEmail: "Check your email",
    resetSent: "We've sent you a link to reset your password.",
    welcome: "Welcome!",
    loginSuccess: "Logged in successfully.",
    accountCreated: "Account created!",
    accountCreatedDesc: "Your account has been created successfully.",
    accountCreatedConfirmEmailDesc: "We've sent you a confirmation email. Open it to activate your account before signing in.",
    accountAlreadyExistsDesc: "An account with this email already exists. Check your inbox or try signing in.",
    invalidCredentials: "Incorrect email or password. Try again or reset your password.",
    referralInvite: "You were invited by a creator: sign up to activate the invite.",
    resetEmailSent: "Email sent!",
    resetEmailDesc: "Check your inbox for the reset link.",
    error: "Error",
    passwordHint: "At least 6 characters. Avoid common passwords like \"123456\" or \"password\".",
    passwordWeakError: "This password is too common or compromised. Please choose a stronger one.",
    quickStart: "Get started in 10 seconds",
    quickStartDesc: "No card required · 7 days free · Cancel anytime",
    useEmail: "Continue with email",
    benefit1: "Unlimited bio links",
    benefit2: "Real-time detailed analytics",
    benefit3: "Sell products & services with no fees",
  },
  resetPassword: {
    backToLogin: "Back to login",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    update: "Update password",
    updating: "Updating...",
    updated: "Password updated",
    updatedDesc: "You can now log in with your new password.",
    goToLogin: "Go to login",
    invalidLink: "Invalid link",
    invalidLinkDesc: "This reset link is invalid or expired. Request a new link from the login page.",
    enterNew: "Enter your new password",
    mismatch: "Passwords do not match.",
    tooShort: "Password must be at least 6 characters.",
    success: "Password updated!",
    successDesc: "Your password has been changed successfully.",
    error: "Error",
  },
  notFound: {
    title: "404",
    message: "Oops! Page not found",
    backHome: "Back to Home",
  },
  contatti: {
    back: "Back to home",
    title: "Contact Us",
    desc: "Send suggestions, report bugs or ask questions",
    categories: {
      suggestion: "💡 Suggestion",
      bug: "🐛 Bug",
      question: "❓ Question",
      other: "📝 Other",
    },
    yourEmail: "Your email",
    category: "Category",
    subject: "Subject",
    subjectPlaceholder: "What is this about?",
    message: "Message",
    messagePlaceholder: "Describe in detail...",
    send: "Send message",
    sending: "Sending...",
    sent: "Message sent!",
    sentDesc: "Thanks for writing to us, we'll get back to you soon.",
    sendAnother: "Send another message",
    enterEmail: "Enter your email",
    error: "Error",
    errorDesc: "Could not send the message.",
  },
  chiSiamo: {
    badge: "Our mission",
    title1: "We help creators ",
    titleHighlight: "sell more",
    desc: "TuttiIMieiLink was born with a clear goal: to transform your link-in-bio from a simple list of links into a powerful sales tool, with analytics, deeplink and protection from reports.",
    stats: [
      { value: "10K+", label: "Active creators" },
      { value: "50K+", label: "Pages created" },
      { value: "2M+", label: "Clicks tracked" },
      { value: "99.9%", label: "Guaranteed uptime" },
    ],
    timelineTitle: "Our journey",
    milestones: [
      { year: "2024", title: "The idea is born", desc: "Tired of generic link-in-bio tools that don't convert, we started building something different." },
      { year: "2024", title: "Beta launch", desc: "First 500 pages created. Creator feedback guided us toward Deeplink™ and advanced analytics." },
      { year: "2025", title: "Explosive growth", desc: "10,000+ creators rely on TuttiIMieiLink to sell digital products and grow their brand." },
      { year: "2025", title: "The future", desc: "A/B testing, pixel tracking, lead capture and much more. We're just getting started." },
    ],
    earningBadge: "ONLY PLATFORM",
    earningTitle1: "We pay you for every ",
    earningTitleHighlight: "click received",
    earningDesc: "We're the only link-in-bio platform that shares revenue with creators. The more traffic you bring, the more you earn. It's simple.",
    earningCards: [
      { title: "€0.005 / click", subtitle: "Free Plan", desc: "Even with the free plan you start earning for every click received on your links." },
      { title: "€0.01 / click", subtitle: "Premium Plan", desc: "With Creator or Agency you double the earnings per click. Double the value, same traffic.", recommended: "RECOMMENDED" },
      { title: "€10 threshold", subtitle: "PayPal Payout", desc: "Reach €10 balance and request payment directly to your PayPal account." },
    ],
    howItWorksTitle: "How does it work?",
    howItWorksSteps: [
      "Create your page and add your links",
      "Share your link-in-bio on social media",
      "Every click is tracked and credited",
      "Reach €10 and request your PayPal payout",
    ],
    valuesTitle: "Our values",
    valuesDesc: "Everything we do is guided by these principles.",
    values: [
      { title: "Conversions first", desc: "Every feature is designed to help you sell more, not just look pretty." },
      { title: "Creator protection", desc: "Deeplink™ and Shield protect your account from reports." },
      { title: "Community driven", desc: "Creator feedback guides every product decision we make." },
    ],
  },
  terms: {
    title: "Terms of Use",
    lastUpdate: "Last updated: March 2026",
    sections: [
      { title: "1. Acceptance of terms", content: "By accessing and using TuttiIMieiLink (\"the Platform\"), you agree to be bound by these Terms of Use. If you do not accept these terms, please do not use the service." },
      { title: "2. Service description", content: "TuttiIMieiLink is a platform that allows creators to create customized link-in-bio pages, sell digital products, collect leads and monitor performance through advanced analytics." },
      { title: "3. Registration and account", content: "To use certain features of the Platform, it is necessary to create an account. The user is responsible for the confidentiality of their credentials and all activities performed through their account." },
      { title: "4. Plans and payments", content: "The Platform offers free and paid plans. Paid plans are billed monthly or annually through Stripe. Users can manage or cancel their subscription at any time from the dashboard." },
      { title: "5. User content", content: "The user retains ownership of all content uploaded to the Platform. They grant TuttiIMieiLink a limited license to host and display such content for the purpose of providing the service." },
      { title: "6. Acceptable use", content: "The user agrees not to use the Platform for illegal purposes, to spread offensive content, spam or malware. TuttiIMieiLink reserves the right to suspend accounts that violate these terms." },
      { title: "7. Click earnings program", content: "Users can earn a commission for each click received on their pages. Rates and payment conditions are subject to change with notice. Withdrawal is available upon reaching the minimum threshold of €10." },
      { title: "8. Limitation of liability", content: "The Platform is provided \"as is\". TuttiIMieiLink does not guarantee uninterrupted operation and is not responsible for any damages arising from the use of the service." },
      { title: "9. Changes to terms", content: "TuttiIMieiLink reserves the right to modify these terms at any time. Changes will be communicated via email or notification on the Platform." },
      { title: "10. Contact", content: "For questions regarding these terms, contact us on the <a>Contact</a> page." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdate: "Last updated: March 2026",
    sections: [
      { title: "1. Data controller", content: "The data controller is TuttiIMieiLink. To contact us, visit the <a>Contact</a> page." },
      { title: "2. Data collected", content: "We collect the following data:", list: ["Registration data: email, display name", "Usage data: page views, link clicks, referrer", "Payment data: managed entirely by Stripe; we do not store credit card data", "Technical data: IP address, browser, device (for analytics)"] },
      { title: "3. Purpose of processing", content: "Data is used to:", list: ["Provide the service and manage the user account", "Provide analytics and statistics on page performance", "Manage payments and subscriptions", "Calculate click earnings", "Improve the service and user experience"] },
      { title: "4. Legal basis", content: "Data processing is based on the user's consent at registration and the execution of the service contract." },
      { title: "5. Data sharing", content: "We do not sell user data to third parties. We share data only with:", list: ["Stripe: for payment management", "Hosting provider: for service delivery"] },
      { title: "6. Data retention", content: "Data is retained for the duration of the active account and for the period required by applicable regulations after cancellation." },
      { title: "7. User rights", content: "In compliance with GDPR, the user has the right to:", list: ["Access their personal data", "Request rectification or deletion of data", "Object to processing", "Request data portability"] },
      { title: "8. Security", content: "We adopt technical and organizational security measures to protect personal data, including communication encryption and restricted data access." },
    ],
  },
  cookie: {
    title: "Cookie Policy",
    lastUpdate: "Last updated: March 2026",
    sections: [
      { title: "1. What are cookies", content: "Cookies are small text files stored on the user's device when visiting a website. They are used to improve the browsing experience and provide essential functionality." },
      { title: "2. Cookies used", content: "" },
      { title: "Technical cookies (necessary)", content: "These cookies are essential for the Platform's operation:", list: ["Authentication session: to maintain account access", "User preferences: to store settings"], isH3: true },
      { title: "Analytical cookies", content: "We use analytical cookies to understand how users interact with the Platform:", list: ["Google Analytics: if configured by the user on their pages", "Internal analytics: to track views and clicks"], isH3: true },
      { title: "Third-party cookies", content: "Some cookies may be set by third-party services:", list: ["Stripe: for secure payment management", "Meta Pixel / TikTok Pixel: if configured by the user on their pages"], isH3: true },
      { title: "3. Cookie management", content: "Users can manage cookie preferences through their browser settings. Disabling certain cookies may affect the Platform's functionality." },
      { title: "4. Cookie duration", content: "", list: ["Session cookies: deleted when the browser is closed", "Persistent cookies: remain on the device for a defined period or until manually deleted"] },
      { title: "5. Updates", content: "This Cookie Policy may be updated periodically. Any changes will be published on this page." },
      { title: "6. Contact", content: "For questions about the Cookie Policy, visit the <a>Contact</a> page." },
    ],
  },
  copilot: {
    title: "Growth Copilot",
    intro: "Your AI strategist: it reads your page's real data (views, clicks, sales, leads) and tells you what to do next.",
    empty: "Ask me anything about growing your page.",
    thinking: "Analyzing your data…",
    placeholder: "e.g. How do I get more clicks on my links?",
    errTitle: "Copilot unavailable",
    errRate: "Too many requests, try again shortly.",
    errCredits: "AI credits exhausted.",
    errNoPage: "Create your page first.",
    errGeneric: "Something went wrong, try again.",
    suggestions: [
      "What should I improve this week?",
      "How do I get more clicks on my links?",
      "How can I earn more from my page?",
      "Analyze my funnel and tell me where I lose visitors",
    ],
  },
  dashboard: {
    home: "Home",
    yourPage: "Your page",
    yourPageDesc: "Create and customize your link-in-bio page",
    editPage: "Edit Page",
    editLinks: "Your Links",
    analyticsTitle: "Analytics",
    feedback: "Feedback",
    referral: "Referral",
    earnings: "Earnings",
    collaborations: "Collaborations",
    testimonials: "Testimonials",
    socialProof: "Social Proof",
    abTest: "A/B Test",
    loading: "Loading...",
    subscription: "Subscription",
    refresh: "Refresh",
    checking: "Checking...",
    activePlan: "Active plan",
    nextRenewal: "Next renewal:",
    manageSubscription: "Manage subscription",
    freePlan: "Free Plan",
    noSubscription: "No active subscription",
    choosePlan: "Choose a plan",
    premiumFeature: "Premium Feature",
    upgradeToAccess: "Upgrade to a PRO plan to access this feature.",
    unlockTitle: "Unlock full potential",
    unlockDesc: "Upgrade to a premium plan to access <strong>advanced analytics</strong>, <strong>digital products</strong>, <strong>lead capture</strong>, <strong>pixel tracking</strong>, <strong>A/B testing</strong> and unlimited links.",
    discoverPlans: "Discover premium plans",
    lockedAnalytics: "Analytics",
    lockedProducts: "Products",
    lockedAI: "AI",
    lockedBooking: "Booking",
    lockedMembership: "Membership",
    lockedSmartBio: "Smart Bio",
    portalError: "Unable to open the portal.",
    trialTitle: "Free trial",
    trialRemaining: "{{days}} days left in your trial",
    trialUrgent: "Only {{days}} days and {{hours}} hours left!",
    trialProgress: "Day {{used}} of {{total}}",
    trialCta: "Activate your plan now so you don't lose access to premium features.",
    trialUpgrade: "Activate plan",
    error: "Error",
    saved: "Saved!",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    delete: "Delete",
    add: "Add",
    pageSettings: "Page settings",
    pagePhoto: "Page photo",
    uploading: "Uploading...",
    usernameLabel: "Username (page URL)",
    usernamePlaceholder: "yourusername",
    usernameRequired: "Username is required.",
    usernameInvalid: "Username can only contain letters, numbers, - and _",
    titleLabel: "Title",
    titlePlaceholder: "Your name or brand",
    bioLabel: "Bio",
    bioPlaceholder: "Describe who you are...",
    themeLabel: "Page theme",
    customizeColors: "Customize colors",
    resetDefault: "Reset to default",
    colorBg: "Background",
    colorCard: "Card",
    colorText: "Text",
    colorAccent: "Accent",
    fontLabel: "Page font",
    previewLabel: "Theme preview",
    saveSettings: "Save settings",
    settingsSaved: "Page settings have been updated.",
    duplicateUsername: "This username is already taken. Choose another one.",
    cantSave: "Unable to save settings.",
    deletePage: "Delete page",
    deletePageConfirm: "Delete the page?",
    deletePageDesc: "This action is irreversible. The page, all links and associated statistics will be permanently deleted.",
    deleting: "Deleting...",
    deleteForever: "Delete permanently",
    pageDeleted: "Page deleted",
    pageDeletedDesc: "Your page has been removed.",
    cantDelete: "Unable to delete the page.",
    photoUpdated: "Photo updated!",
    photoTooBig: "Image must be under 2MB.",
    cantUploadPhoto: "Unable to upload the photo.",
    yourName: "Your name",
    yourBio: "Your bio...",
    previewInstagram: "Instagram",
    previewYouTube: "YouTube",
    previewWebsite: "My website",
    yourLinks: "Your links",
    savePageFirst: "Save page settings first to add links.",
    linkTitlePlaceholder: "Link title",
    linkUrlPlaceholder: "https://example.com",
    linkAdded: "Link added!",
    cantAddLink: "Unable to add the link.",
    invalidUrl: "The URL entered is not valid.",
    urlNotReachable: "The website does not exist or is unreachable. Please check the URL and try again.",
    cantLoadLinks: "Unable to load links.",
    linkDeleted: "Link deleted.",
    linkUpdated: "Link updated!",
    cantUpdateLink: "Unable to update the link.",
    noLinksYet: "No links yet. Add one above!",
    linkLimitReached: "Limit reached",
    linkLimitDesc: "The free plan allows max {{limit}} links. Upgrade to a paid plan for unlimited links.",
    linkLimitUpgrade: "You've reached the {{limit}} link limit on the free plan.",
    upgradeToCreator: "Upgrade to Creator",
    unlimitedLinks: "for unlimited links.",
    analytics: "Analytics",
    totalViews: "Total views",
    totalClicks: "Total clicks",
    ctr: "CTR",
    sales: "Sales",
    revenue: "Revenue",
    leadsCollected: "Leads collected",
    last30days: "Last 30 days",
    salesAndRevenue: "Sales and revenue (30 days)",
    clicksPerLink: "Clicks per link",
    topReferrer: "Top referrers",
    noReferrerYet: "No referrers recorded yet.",
    visits: "visits",
    visitsChart: "Views",
    clicksChart: "Clicks",
    salesChart: "Sales",
    revenueChart: "Revenue",
    products: "Products",
    digitalProducts: "Digital Products",
    digitalProductsLockedDesc: "Product sales are available with the Creator plan or higher.",
    digitalProductsSellDesc: "Sell ebooks, templates, courses and physical products directly from your page.",
    unlockWithCreator: "Unlock with Creator",
    discoverPlansLink: "Discover plans",
    productNamePlaceholder: "Product name *",
    productDescPlaceholder: "Description (optional)",
    productPricePlaceholder: "Price (€) *",
    productFilePlaceholder: "Product file (PDF, ZIP...)",
    productCoverPlaceholder: "Cover image",
    invalidPrice: "Invalid price",
    productCreated: "Product created!",
    createProduct: "Create product",
    productUpdated: "Product updated!",
    replaceFile: "Replace file",
    addFile: "Add file",
    replaceCover: "Replace cover",
    addCover: "Add cover",
    noFile: "No file",
    deleteProductConfirm: "Delete this product?",
    deleteAllProducts: "Delete all",
    deleteAllProductsConfirm: "Are you sure you want to delete ALL products? This action is irreversible.",
    allProductsDeleted: "All products have been deleted",
    noProductsYet: "No products yet. Add your first product!",
    typeDigital: "Digital",
    typePhysical: "Physical",
    physicalProductNote: "For physical products, shipping address will be collected at checkout. You'll receive the order details and address via email.",
    shippingCostPlaceholder: "Shipping cost (€)",
    shippingCostHint: "0 = free shipping",
    shipping: "Shipping",
    csvImportTitle: "Import from CSV / Excel",
    csvImportDesc: "Upload a CSV or Excel file with columns: title, description, price, currency. Products will be created as physical.",
    csvSelectFile: "Select CSV or Excel file",
    csvDownloadTemplate: "Download template",
    csvNoRows: "The file contains no data rows.",
    csvRow: "Row",
    csvMissingTitle: "missing title",
    csvInvalidPrice: "invalid price:",
    csvMaxRows: "Maximum 100 products per import.",
    csvParseError: "Error reading the file. Check the format.",
    csvImportSuccess: "{{count}} products imported successfully!",
    csvImporting: "Importing...",
    csvConfirmImport: "Import {{count}} products",
    csvHeaderTitle: "Title",
    csvHeaderDesc: "Description",
    csvHeaderPrice: "Price",
    ordersTitle: "Physical product orders",
    ordersDesc: "{{count}} orders received",
    orderBuyer: "Buyer",
    orderAddress: "Shipping address",
    orderShippingStatus: "Shipping status",
    orderNotes: "Notes",
    orderNotesPlaceholder: "Tracking number, internal notes...",
    orderUpdated: "Order updated",
    orderDate: "Date",
    orderProduct: "Product",
    orderBuyerName: "Recipient name",
    orderPrice: "Price",
    csvExported: "CSV exported successfully",
    noAddress: "Address not available",
    orderStatus_pending: "Pending",
    orderStatus_processing: "Processing",
    orderStatus_shipped: "Shipped",
    orderStatus_delivered: "Delivered",
    earningsRateInfo: "You earn <strong>{{rate}}</strong> per click on your links.",
    earningsUpgrade: "Upgrade to premium to double it!",
    earningsPPCOnly: "This is the Pay-Per-Click program only. Donations and memberships go directly to your Stripe — ",
    stripeDashboardLink: "manage your bank account at dashboard.stripe.com",
    openStripeDashboard: "Open Stripe Dashboard",
    balance: "Balance",
    totalEarned: "Total earned",
    withdrawn: "Withdrawn",
    paypalEmail: "PayPal Email",
    paypalPlaceholder: "your-email@paypal.com",
    paypalSaved: "PayPal email updated.",
    requestPayout: "Request payout",
    payoutMin: "min. {{amount}}",
    payoutSending: "Sending...",
    payoutSent: "Request sent!",
    payoutSentDesc: "Payout of €{{amount}} is being processed.",
    payoutMissingEmail: "Enter your PayPal email first.",
    payoutMissing: "{{amount}} remaining to reach the minimum threshold.",
    payoutHistory: "Request history",
    payoutCompleted: "Completed",
    payoutRejected: "Rejected",
    payoutPending: "Pending",
    attention: "Attention",
    onboardingWelcome: "Welcome! Let's set up your page",
    onboardingSubtitle: "Just 3 steps to go online",
    publishBannerTitle: "Your page isn't live yet — publish it now",
    publishBannerDesc: "You're one step away: pick your username, add your first link and your page is ready to share in your social bios. It takes 2 minutes.",
    onboardingStep1: "Profile",
    onboardingStep1Desc: "Choose your username",
    onboardingStep2: "Customize",
    onboardingStep2Desc: "Title and bio",
    onboardingStep3: "First link",
    onboardingStep3Desc: "Add a link",
    profilePhoto: "Profile photo",
    profilePhotoHint: "Optional, max 2MB",
    chooseUsername: "Choose your username",
    usernameMin3: "Minimum 3 characters",
    pageTitle: "Page title",
    pageBio: "Bio",
    pageBioPlaceholder: "Describe who you are in a few words...",
    editLaterHint: "You can edit everything later from the dashboard.",
    firstLinkHint: "Add your first link. You can add more later.",
    linkTitleExample: "e.g. Instagram",
    linkUrlExample: "https://instagram.com/yourprofile",
    optionalStep: "This step is optional — you can skip it.",
    back: "Back",
    next: "Next",
    creating: "Creating...",
    createMyPage: "Create my page",
    pageReady: "Your page is ready! 🎉",
    pageReadyDesc: "Awesome! Your link-in-bio page has been created successfully.",
    goToDashboard: "Go to dashboard",
    pageCreatedToast: "Page created! 🎉",
    pageCreatedToastDesc: "Now customize your dashboard.",
    usernameInUse: "Username already taken. Choose another one.",
    pageCreateError: "Error creating the page.",
    uploadFailed: "Upload failed.",
    // Onboarding Checklist
    checklistTitle: "Set up your page",
    checklistAllDone: "All done! 🎉",
    checklistDismiss: "Hide checklist",
    checklistAvatar: "Add a profile photo",
    checklistAvatarDesc: "Profiles with photos get 40% more clicks.",
    checklistBio: "Write a bio",
    checklistBioDesc: "Tell visitors who you are and what you do.",
    checklistLinks: "Add at least 3 links",
    checklistLinksDesc: "More links = more conversion opportunities.",
    checklistShare: "Share your page",
    checklistShareDesc: "Send the link to your followers on social media.",
    checklistShareAction: "Share",
    checklistPremium: "Activate a Premium plan",
    checklistPremiumDesc: "Unlock analytics, lead capture and earnings per click.",
    checklistPremiumAction: "See plans",
    openPage: "Open page",
    copyUrl: "Copy URL",
    qrCode: "QR Code",
    downloadPng: "Download PNG",
    contactTeam: "Contact the team",
    contactTeamDesc: "Send suggestions, report bugs or ask questions",
    feedbackSent: "Message sent!",
    feedbackSentDesc: "Thanks for your feedback, we'll read it soon.",
    categoryLabel: "Category",
    categorySuggestion: "💡 Suggestion",
    categoryBug: "🐛 Bug",
    categoryQuestion: "❓ Question",
    categoryOther: "📝 Other",
    subjectLabel: "Subject",
    subjectPlaceholder: "What is this about?",
    messageLabel: "Message",
    messagePlaceholder: "Describe in detail...",
    sendMessage: "Send message",
    sending: "Sending...",
    feedbackReplies: "{{count}} reply/replies from the team",
    feedbackAdminReply: "Team reply",
    leadCapture: "Lead Capture",
    leadCaptureLockedTitle: "Feature available with Creator or Agency plan",
    leadCaptureLockedDesc: "Collect emails and contacts directly from your page.",
    upgrade: "Upgrade",
    enableFormOnPage: "Enable form on page",
    enableFormDesc: "Visitors will be able to subscribe to your list",
    formTitle: "Form title",
    formDescription: "Description",
    leadMagnetUrl: "Lead Magnet URL (optional)",
    leadMagnetPlaceholder: "https://example.com/ebook.pdf",
    leadMagnetHint: "After subscribing, the user will be redirected to this link.",
    leadsCollectedCount: "Leads collected ({{count}})",
    exportCsv: "Export CSV",
    noLeadsYet: "No leads yet. Enable the form and share your page!",
    leadDeleted: "Lead deleted.",
    leadCaptureSaved: "Lead capture settings have been updated.",
    cantSaveLead: "Unable to save.",
    pixelTracking: "Pixel Tracking",
    pixelTrackingLockedDesc: "Track conversions with Meta Pixel, TikTok Pixel and Google Analytics directly from your page.",
    metaPixelId: "Meta Pixel ID",
    metaPixelPlaceholder: "e.g. 123456789012345",
    metaPixelHint: "Find the ID in your Meta Events Manager",
    tiktokPixelId: "TikTok Pixel ID",
    tiktokPixelPlaceholder: "e.g. ABCDEF123456",
    tiktokPixelHint: "Find the ID in TikTok Ads Manager → Events",
    googleAnalyticsId: "Google Analytics ID",
    googleAnalyticsPlaceholder: "e.g. G-XXXXXXXXXX",
    googleAnalyticsHint: "Find the ID in Google Analytics → Admin → Data Streams",
    pixelSaved: "Pixels saved!",
    savePixels: "Save pixels",
    abTestPosition: "A/B Test Position",
    abTestLockedDesc: "Automatically test the order of links on your page to discover which position generates more clicks.",
    abTestEnabled: "Link order is randomized for each visitor. Data updates as you collect clicks.",
    abTestDisabled: "Enable to show links in random order to visitors and discover which position performs best.",
    abTestActivated: "A/B Test activated!",
    abTestDeactivated: "A/B Test deactivated",
    trackedClicksWithPos: "Tracked clicks with position",
    noDataYetEnabled: "No data yet. Results will appear when visitors start clicking.",
    noDataYetDisabled: "Enable A/B testing to start collecting data.",
    resultsPerLink: "Results per link",
    deletedLink: "Deleted link",
    positionLabel: "Pos.",
    positionWinner: "🏆 Position {{pos}} is the winner",
    clicks: "clicks",
    defaultFormTitle: "Subscribe to the newsletter",
    defaultFormDesc: "Receive exclusive updates directly in your inbox.",
    bundleTitle: "Bundle",
    createBundle: "Create bundle",
    bundleNamePlaceholder: "Bundle name (e.g. Complete Pack)",
    bundleDescPlaceholder: "Description (optional)",
    percentDiscount: "% discount",
    fixedDiscount: "cents discount",
    selectProducts: "Select products ({{count}} selected):",
    selectMin2: "Select at least 2 products",
    noProductsForBundle: "No products. Create digital products first.",
    originalPrice: "Original price",
    bundleCreated: "Bundle created!",
    invalidDiscount: "Invalid discount",
    deleteBundleConfirm: "Delete this bundle?",
    noBundlesYet: "No bundles created. Create product packages at a discounted price!",
    bundleProducts: "products",
  },
  seoCreator: {
    metaTitle: "Link in Bio for Creators | TuttiIMieiLink",
    metaDesc: "Create your professional link in bio for creators. Collect leads, sell digital products and track conversions with TuttiIMieiLink.",
    badge: "For Creators",
    title: "The link in bio that ",
    titleHighlight: "truly converts",
    desc: "Not a simple link-in-bio. TuttiIMieiLink is the tool built for creators who want to turn followers into customers, collect leads and sell digital products.",
    cta: "Start for free",
    viewPlans: "View plans",
    whyTitle: "Why creators choose TuttiIMieiLink",
    whyDesc: "Generic link-in-bio tools aren't enough anymore. You need a tool that helps you monetize, not just collect clicks.",
    features: [
      { title: "Unlimited links", desc: "Add all the links you want: social, website, portfolio, courses and more." },
      { title: "Sell digital products", desc: "Sell ebooks, presets, templates and courses directly from your page." },
      { title: "Advanced analytics", desc: "Track visits, clicks, CTR, sales and revenue in real time." },
      { title: "Customizable themes", desc: "Choose from premium themes and customize colors, fonts and style." },
      { title: "A/B Test positioning", desc: "Test link order to discover which position converts best." },
      { title: "Lead capture", desc: "Collect emails and names from your visitors with built-in forms." },
    ],
    proofTitle: "Built for content creators",
    proofDesc: "Whether you're an influencer, coach, artist or freelancer, TuttiIMieiLink gives you the tools to turn your audience into a business.",
    stats: [
      { value: "+47%", label: "Average CTR" },
      { value: "3x", label: "More sales" },
      { value: "2min", label: "Initial setup" },
    ],
    jsonLdDesc: "Professional link in bio for creators. Sell digital products, collect leads and track conversions.",
  },
  seoInstagram: {
    metaTitle: "Link in Bio for Instagram | TuttiIMieiLink",
    metaDesc: "The best link in bio for Instagram. Add multiple links, sell products and track clicks from your Instagram bio with TuttiIMieiLink.",
    badge: "For Instagram",
    title: "The perfect link in bio for ",
    titleHighlight: "Instagram",
    desc: "Instagram gives you only one link in your bio. TuttiIMieiLink lets you add as many as you want, sell products and track every click.",
    cta: "Create your link in bio",
    problemsTitle: "The Instagram bio link problem",
    problems: [
      { title: "Only one link in bio", desc: "Instagram allows one link. With TuttiIMieiLink you add as many as you want." },
      { title: "No click data", desc: "Don't know which links work? Our analytics tell you everything." },
      { title: "Zero sales from bio", desc: "Add digital products and sell directly from your link-in-bio page." },
    ],
    howTitle: "How it works",
    steps: [
      { title: "Create your account", desc: "Sign up for free in 30 seconds and choose your custom username." },
      { title: "Add your links", desc: "Add links to your site, YouTube, shop, courses or any other resource." },
      { title: "Paste in your bio", desc: "Copy your page link and paste it in your Instagram bio. Done!" },
    ],
    featuresTitle: "Everything you need",
    features: [
      { title: "Multiple links", desc: "Add as many links as you want to your page." },
      { title: "Real-time analytics", desc: "Visits, clicks, CTR and referrer for each link." },
      { title: "Customizable design", desc: "Themes, colors and fonts that reflect your brand." },
      { title: "Product sales", desc: "Sell ebooks, presets and courses from your bio." },
    ],
    jsonLdDesc: "Link in bio for Instagram. Add multiple links, sell products and track conversions.",
  },
  seoMonetize: {
    metaTitle: "How to Monetize Instagram | TuttiIMieiLink",
    metaDesc: "Discover how to monetize Instagram in 2026. Sell digital products, collect leads and turn followers into customers with TuttiIMieiLink.",
    badge: "Monetization guide",
    title: "How to ",
    titleHighlight: "monetize Instagram",
    titleEnd: " in 2026",
    desc: "Followers don't pay the bills. Discover how to turn your Instagram audience into a real business with concrete strategies and professional tools.",
    cta: "Start monetizing",
    problemTitle: "The problem: followers ≠ money",
    problemDesc: "Having thousands of followers isn't enough. Without a clear monetization strategy, you're leaving money on the table. The good news? You don't need millions of followers to earn. You need the right tools.",
    problemStats: [
      { stat: "82%", label: "of creators don't monetize" },
      { stat: "1k", label: "followers are enough" },
      { stat: "€500+", label: "per month possible" },
      { stat: "2 min", label: "to get started" },
    ],
    strategiesTitle: "4 strategies to monetize Instagram",
    strategiesDesc: "Here's how successful creators earn with Instagram using TuttiIMieiLink.",
    strategies: [
      { title: "Sell digital products", desc: "Ebooks, Lightroom presets, Canva templates, online courses. Create once, sell forever directly from your link in bio." },
      { title: "Collect emails", desc: "Use the built-in lead capture to build your mailing list. Offer a freebie in exchange for email and nurture your contacts." },
      { title: "Optimize with data", desc: "Analyze which links generate more clicks, which position converts best and where your traffic comes from." },
      { title: "Automatic A/B testing", desc: "Test link order to maximize conversions. The system automatically identifies the winner." },
    ],
    readyTitle: "Ready to monetize?",
    readyDesc: "Start free today. Create your page, add your products and start earning from your Instagram followers.",
    readyCta: "Create your free account",
    jsonLdHeadline: "How to Monetize Instagram in 2026",
    jsonLdDesc: "Complete guide to monetize Instagram with digital products, lead capture and analytics.",
  },
  referralBanner: {
    badge: "Referral Program",
    title: "Invite a creator, earn 20% recurring",
    desc: "Share your invite link. For every creator who subscribes through you, you automatically earn 20% of their subscription. Every month. Forever.",
    step1Title: "Share the link",
    step1Desc: "From your dashboard",
    step2Title: "Earn 20%",
    step2Desc: "On every renewal",
    cta: "Start inviting",
  },
  referral: {
    title: "Referral Program",
    desc: "Invite other creators and earn a recurring 20% commission on every subscription they generate.",
    yourLink: "Your referral link",
    copied: "Link copied!",
    invited: "Invited",
    subscribed: "Subscribed",
    earned: "Earned",
    history: "Commission history",
    howTitle: "How does it work?",
    howDesc: "Share your link. When someone signs up and subscribes, you automatically earn 20% of their subscription every month.",
  },
  seoProducts: {
    metaTitle: "Sell Digital Products on Instagram | TuttiIMieiLink",
    metaDesc: "Sell digital products on Instagram: ebooks, presets, templates and courses. Built-in checkout, zero platform fees. Start free with TuttiIMieiLink.",
    badge: "Digital products",
    title: "Sell ",
    titleHighlight: "digital products",
    titleEnd: " on Instagram",
    desc: "Turn your skills into digital products and sell them directly from your Instagram bio. No website, no complexity. Just sales.",
    cta: "Start selling",
    typesTitle: "What you can sell",
    typesDesc: "Any digital file can become a product. Here are the most requested categories by creators.",
    types: [
      { title: "Ebooks and guides", desc: "PDF guides, recipe books, technical manuals. Create once, sell forever." },
      { title: "Presets and templates", desc: "Lightroom presets, Canva templates, custom filters for your followers." },
      { title: "Courses and workshops", desc: "Video courses, recorded webinars, educational material in digital format." },
      { title: "Premium resources", desc: "Checklists, planners, spreadsheets and any useful resource for your niche." },
    ],
    howTitle: "How selling works",
    howSteps: [
      { title: "Upload your product", desc: "Add title, description, price and upload the file from the dashboard." },
      { title: "Customer pays from your page", desc: "The visitor clicks 'Buy', enters email and pays securely with Stripe." },
      { title: "Automatic download", desc: "After payment, the customer receives a unique and secure download link." },
    ],
    benefitsTitle: "Why sell with TuttiIMieiLink",
    benefits: [
      "Secure checkout with integrated Stripe",
      "Automatic download after payment",
      "Zero platform fees",
      "Manage everything from the dashboard",
      "Real-time sales analytics",
      "Customizable product cover",
    ],
    jsonLdHeadline: "How to Sell Digital Products on Instagram",
    jsonLdDesc: "Complete guide to sell ebooks, presets, templates and courses on Instagram with TuttiIMieiLink.",
  },
  ai: {
    generating: "Generating...",
    generateBio: "Generate with AI",
    suggestTitle: "Suggest title",
    generateDesc: "Generate AI description",
    error: "AI Error",
    generateError: "Could not generate content. Please try again.",
  },
  routing: {
    smartRouting: "Smart Routing",
    country: "Country",
    device: "Device",
    language: "Language",
    selectValue: "Select...",
    altUrlPlaceholder: "Alternative URL",
    addRule: "Add rule",
    ruleAdded: "Rule added",
    ruleDeleted: "Rule deleted",
    rulesLabel: "Routing rules",
  },
  testimonials: {
    title: "Testimonials",
    add: "Add",
    addBtn: "Add",
    cancel: "Cancel",
    namePlaceholder: "Customer name",
    rolePlaceholder: "Role / company (optional)",
    quotePlaceholder: "Write the customer review...",
    rating: "Rating",
    added: "Testimonial added",
    deleted: "Testimonial deleted",
    photoUploaded: "Photo uploaded",
    error: "Error saving",
    empty: "No testimonials yet. Add one to show on your page!",
    hint: "Active testimonials will be displayed on your public page.",
  },
  seoFree: {
    metaTitle: "Free Link in Bio | Create Your Page in 2 Minutes | TuttiIMieiLink",
    metaDesc: "Create your free link in bio with TuttiIMieiLink. Customizable page, analytics, digital product sales and earnings per click. Better than Linktree. Start now.",
    badge: "100% Free · No credit card required",
    title: "The best free ",
    titleHighlight: "link in bio for creators",
    desc: "Create your link-in-bio page in 2 minutes. Customize it, add your links, sell digital products and earn from every click. All free, forever.",
    cta: "Create your free link",
    viewPlans: "View plans",
    subCta: "No credit card · 2-minute setup",
    featuresTitle: "Everything you need, for free",
    featuresDesc: "While others charge for basic features, we give them to you for free. Really.",
    features: [
      { title: "Unlimited links", desc: "Add as many links as you want to your page. No artificial limits." },
      { title: "Customizable themes", desc: "Choose from multiple themes and fonts to make your page unique." },
      { title: "Built-in analytics", desc: "Track views, clicks and conversions with the dedicated dashboard." },
      { title: "Digital product sales", desc: "Sell ebooks, courses and templates directly from your page." },
      { title: "Personal QR Code", desc: "Generate and download your page's QR code to share it anywhere." },
      { title: "Earnings per click", desc: "The only platform that pays you for every click on your page." },
    ],
    howTitle: "Create your link in bio in 3 steps",
    steps: [
      { title: "Sign up for free", desc: "Create your account in seconds with email or Google. No card required." },
      { title: "Customize your page", desc: "Pick a theme, add links to your socials, website and content." },
      { title: "Share and earn", desc: "Copy your link and add it to your Instagram, TikTok or YouTube bio. Start earning." },
    ],
    compTitle: "TuttiIMieiLink vs other free link in bio tools",
    compDesc: "Not all free link in bio tools are created equal. Here's what makes us different.",
    compOthers: "Other tools",
    comparisons: [
      { them: "Max 5 links", us: "Unlimited links" },
      { them: "No earnings", us: "Earnings per click" },
      { them: "Limited analytics", us: "Full analytics" },
      { them: "No product sales", us: "Integrated sales" },
      { them: "Platform branding", us: "Your brand" },
    ],
    proofTitle: "The numbers speak for themselves",
    stats: [
      { value: "1,000+", label: "Active creators" },
      { value: "€0", label: "To get started" },
      { value: "2 min", label: "Full setup" },
    ],
    jsonLdDesc: "Create your free link in bio with TuttiIMieiLink. Customizable page, analytics, digital product sales and earnings per click.",
  },
  seoInternalLinks: {
    title: "Creator guides and resources",
    body: "Build a <free>free link in bio</free> as a real Linktree alternative, optimize your <ig>link in bio for Instagram</ig> and learn how a <creator>link in bio for creators</creator> converts. Want to earn? Read our guides on how to <monetize>monetize Instagram</monetize> and <sell>sell digital products online</sell>.",
  },
  exitPopup: {
    title: "Wait! Don't leave yet 👋",
    desc: "You're about to miss the chance to turn your followers into customers. Try free for 7 days, risk-free.",
    trialBadge: "7-day free trial",
    benefits: [
      "Landing pages that convert, not just a link list",
      "Sell digital products with zero fees",
      "Earn from every click you receive",
      "Real-time analytics and conversions",
    ],
    cta: "Start your free 7-day trial",
    dismiss: "No thanks, I prefer regular links",
  },
  freeExitPopup: {
    title: "You're leaving money on the table! 💸",
    desc: "Upgrade to PRO now and unlock 2x earnings + all advanced tools.",
    countdown: "Offer expires in {{minutes}}:{{seconds}}",
    discountBadge: "50% off — Just for you",
    benefits: [
      "Earn €0.01/click instead of €0.005",
      "Advanced analytics and conversions",
      "Digital products and memberships",
      "AI Content Generator and Smart Bio",
      "Booking and integrated calendar",
    ],
    cta: "Upgrade to PRO at 50% off",
    dismiss: "I'll stay on the free plan",
  },
  schedule: {
    title: "Scheduling",
    startLabel: "Publish from",
    endLabel: "Hide after",
    from: "From",
    until: "Until",
    clear: "Remove schedule",
    saved: "Schedule saved",
    showCountdown: "Show countdown on page",
    countdownDays: "d",
    countdownHours: "h",
    countdownMinutes: "m",
    countdownSeconds: "s",
    countdownExpired: "Offer expired",
    countdownEndsIn: "Ends in",
  },
  blog: {
    metaTitle: "Blog | Guides for Creators - TuttiIMieiLink",
    metaDesc: "Guides, strategies and tips for creators who want to monetize social media. Discover how to earn with your link in bio.",
    badge: "Blog & Guides",
    title: "Resources for Creators",
    subtitle: "Practical guides, monetization strategies and tips to turn your followers into customers.",
    readMore: "Read article",
    backToList: "Back to blog",
    related: "Related articles",
    faqTitle: "Frequently asked questions",
    ctaInline: {
      title: "Ready to monetize your socials?",
      desc: "Create your professional link-in-bio, sell digital products and earn per click. Setup in 2 minutes.",
      cta: "Start for free",
    },
    ctaSidebar: {
      title: "Create your link-in-bio",
      desc: "The only one that pays you per click",
      benefits: [
        "Customizable page",
        "Digital product sales",
        "Advanced analytics",
        "Earnings per click",
        "Automatic A/B testing",
      ],
      earning: "€0.01 / click",
      cta: "Try free for 7 days",
      sub: "7 days free · Cancel anytime",
    },
  },
  creatorScore: {
    description: "Credibility score automatically calculated based on the creator's activity.",
    levels: {
      legend: "Legend",
      expert: "Expert",
      pro: "Pro",
      rising: "Rising",
      new: "New",
    },
    categories: {
      sales: "Sales",
      reviews: "Reviews",
      activity: "Activity",
      seniority: "Seniority",
    },
  },
  storefront: {
    cart: "Cart",
    cartEmpty: "Your cart is empty",
    suggestions: "You might also like",
    total: "Total",
    emailPlaceholder: "Your email for download",
    checkout: "Proceed to checkout",
    checkoutLoading: "Loading...",
    enterEmail: "Enter your email",
    error: "Error",
    checkoutError: "Unable to start checkout.",
    addToCart: "Add to cart",
    addBundleToCart: "Add bundle to cart",
    bundleOffers: "Bundle Offers",
    includes: "Includes",
    reviews: "Reviews",
    pageNotFound: "Page not found",
    usernameNotExists: "This username doesn't exist yet.",
    pageUnavailable: "Page unavailable",
    pageUnavailableDesc: "This page is not yet public. The owner must activate a plan to make it visible.",
    backHome: "Back to home",
    thankYou: "Thanks for subscribing!",
    downloadSoon: "Your download will open shortly...",
    namePlaceholder: "Your name (optional)",
    emailFieldPlaceholder: "Your email",
    submitting: "Sending...",
    downloadFree: "Download free",
    subscribe: "Subscribe",
    createdWith: "Created with",
    collabPartners: "In collaboration with",
    marketingConsent: "I agree to receive promotional emails. I can unsubscribe at any time.",
  },
  autoFunnel: {
    title: "AI Auto-Funnel",
    description: "AI analyzes your links, products and analytics to suggest optimal ordering, better copy and a personalized conversion strategy.",
    analyze: "Analyze my funnel",
    analyzing: "Analyzing...",
    strategy: "Recommended strategy",
    linkSuggestions: "Link suggestions",
    productTips: "Product tips",
    bioSuggestion: "Suggested bio",
    apply: "Apply",
    applyAll: "Apply all",
    reanalyze: "Re-analyze",
    applied: "Suggestion applied!",
    allApplied: "All changes have been applied!",
    error: "Error",
    analyzeError: "Unable to analyze the funnel.",
  },
  heatmap: {
    title: "Click Heatmap",
    aiTips: "AI Tips",
    hot: "Hot",
    warm: "Warm",
    medium: "Medium",
    cool: "Cool",
    cold: "Cold",
    suggestions: "Suggestions to improve",
    error: "Error",
  },
  socialProof: {
    title: "Live Social Proof",
    description: "Show recent purchase notifications on your public page to boost conversions.",
    saved: "Setting saved!",
    error: "Error saving",
    exampleBought: "just bought",
    ago: "ago",
    bought: "just bought",
    justNow: "just now",
    minAgo: "min ago",
    daysAgo: "d ago",
  },
  collab: {
    title: "Collaborations",
    description: "Promote other creators on your page and they'll promote you back. Set a custom revenue split.",
    invite: "Invite",
    usernamePlaceholder: "Creator username to invite",
    messagePlaceholder: "Message (optional)",
    splitLabel: "Revenue split",
    you: "You",
    partner: "Partner",
    sendInvite: "Send invite",
    cancel: "Cancel",
    loading: "Loading...",
    pendingIncoming: "Incoming invites",
    pendingOutgoing: "Sent invites",
    activeCollabs: "Active collaborations",
    noCollabs: "No active collaborations. Invite a creator to get started!",
    aiTitle: "Find partners with AI",
    aiDescription: "AI scans creator profiles on the platform and suggests the best partners for a mutual shoutout.",
    aiFind: "Find partners",
    aiFinding: "Analyzing...",
    aiEmpty: "No compatible partners found yet. Try again when more creators join.",
    aiError: "Could not generate matches. Please retry.",
    aiRateLimit: "Too many requests, try again shortly.",
    aiNoCredits: "AI credits exhausted.",
    matchScore: "Match",
    useShoutout: "Invite with this message",
    statsTitle: "Shoutout clicks",
    clicksSent: "Sent to partners",
    clicksReceived: "Received from partners",
    last30: "last 30 days",
    active: "Active",
    inviteSent: "Invite sent!",
    accepted: "Collaboration accepted!",
    rejected: "Invite rejected.",
    cancelled: "Collaboration cancelled.",
    accept: "Accept",
    reject: "Reject",
    error: "Error",
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark all as read",
    empty: "No notifications",
  },
  templates: {
    stepLabel: "Template",
    stepDesc: "Choose a starting template",
    chooseHint: "Pick a template to get started faster, or start from scratch.",
    catAll: "All",
    catCreative: "Creative",
    catBusiness: "Business",
    catWellness: "Wellness",
    catFood: "Food",
    catEntertainment: "Entertainment",
    additionalLinks: "Links included in template:",
    blank: "From scratch",
    blankDesc: "Blank page, fully customizable",
    musician: "Musician",
    musicianDesc: "For artists and musicians",
    beautician: "Beautician",
    beauticianDesc: "For beauty salons & spas",
    coach: "Coach",
    coachDesc: "For coaches, consultants & trainers",
    wedding: "Wedding Planner",
    weddingDesc: "For wedding organizers",
    restaurant: "Restaurant",
    restaurantDesc: "For restaurants & eateries",
    tattoo: "Tattoo Artist",
    tattooDesc: "For tattoo artists & studios",
    photographer: "Photographer",
    photographerDesc: "For photographers & studios",
    personalTrainer: "Personal Trainer",
    personalTrainerDesc: "For personal trainers & fitness coaches",
    artist: "Artist",
    artistDesc: "For artists, illustrators & painters",
    nutritionist: "Nutritionist",
    nutritionistDesc: "For nutritionists & dietitians",
    influencer: "Influencer",
    influencerDesc: "For content creators & influencers",
    lawyer: "Lawyer",
    lawyerDesc: "For lawyers & law firms",
    financialAdvisor: "Financial Advisor",
    financialAdvisorDesc: "For financial advisors & wealth managers",
    psychologist: "Psychologist",
    psychologistDesc: "For psychologists & therapists",
    architect: "Architect",
    architectDesc: "For architects & interior designers",
    dj: "DJ",
    djDesc: "For DJs & music producers",
    podcaster: "Podcaster",
    podcasterDesc: "For podcasters & audio creators",
    foodBlogger: "Food Blogger",
    foodBloggerDesc: "For food bloggers & recipe creators",
    pastryChef: "Pastry & Bakery",
    pastryChefDesc: "For pastry shops, cake designers & bakeries",
    mealPlanCreator: "Meal Plan Creator",
    mealPlanCreatorDesc: "For creators selling meal plans & digital recipe books",
    selectPreview: "Select a template to see the preview",
    customize: "Customize",
    theme: "Theme",
    font: "Font",
    accentColor: "Accent color",
    customColor: "Custom",
  },
  smartBio: {
    description: "Customize the bio and link order based on your visitors' traffic source. Visitors from Instagram will see a different bio than those from Google.",
    noRules: "No Smart Bio rules. Add a traffic source to get started.",
    customBio: "Custom bio",
    bioPlaceholder: "Leave empty to use the default bio...",
    linkOrder: "Custom link order",
    addSource: "Add traffic source",
    active: "Active",
    inactive: "Inactive",
    save: "Save Smart Bio rules",
    saving: "Saving...",
    saved: "Smart Bio rules saved!",
    error: "Error saving rules",
  },
  smartBioLanding: {
    badge: "Smart Bio",
    title: "A different bio for every visitor",
    desc: "Visitors from Instagram see different content than those from Google. Personalized bio and automatic link order based on traffic source.",
    from: "from",
    sources: {
      instagram: "Instagram",
      tiktok: "TikTok",
      google: "Google",
      direct: "Direct link",
    },
    features: [
      "Personalized bio for each traffic source",
      "Link order optimized automatically",
      "Supports Instagram, TikTok, Google, Facebook & more",
      "No technical configuration required",
    ],
    demos: [
      { bio: "🔥 Discover the exclusive content I only share on Instagram!", links: ["Latest Reel ▶️", "Instagram Shop", "Filters & Presets", "Newsletter"] },
      { bio: "🎵 My viral trends and exclusive tutorials", links: ["Viral Videos 🔥", "Full Tutorials", "TikTok Shop", "Follow Me"] },
      { bio: "👋 Welcome! Discover my services and digital products", links: ["Services", "Digital Products", "About Me", "Contact"] },
      { bio: "Hi! Here are all my important links 🚀", links: ["Portfolio", "Blog", "Online Shop", "Contact"] },
    ],
    autoLabel: "100% automatic ✨",
  },
  booking: {
    services: "Bookable services",
    addService: "Add service",
    serviceTitle: "Service name (e.g. 1-on-1 Consultation)",
    serviceDesc: "Description (optional)",
    duration: "Duration (min)",
    price: "Price (€)",
    save: "Save",
    free: "Free",
    noServices: "No services created yet.",
    serviceCreated: "Service created!",
    addSlots: "Add availability",
    selectService: "Service",
    chooseService: "Choose a service...",
    date: "Date",
    from: "From",
    to: "To",
    generateSlots: "Generate slots",
    noSlots: "No slots can be generated in this range.",
    slotsCreated: "{{count}} slots created!",
    upcomingSlots: "Upcoming slots",
    booked: "Booked",
    recentBookings: "Recent bookings",
    name: "Name",
    service: "Service",
    dateTime: "Date/Time",
    payment: "Payment",
    paid: "Paid",
    bookSession: "Book a session",
    chooseServicePublic: "Choose a service",
    selectSlot: "Pick a time",
    noAvailableSlots: "No slots available at the moment.",
    back: "Back",
    yourName: "Your name",
    yourEmail: "Your email",
    notesOptional: "Notes (optional)",
    bookNow: "Book now",
    confirmed: "Booking confirmed!",
    confirmationSent: "You'll receive a confirmation email.",
    bookingError: "Booking error",
    tryAgain: "Please try again.",
    payAndBook: "Pay & book",
    confirmingPayment: "Confirming payment...",
    paymentConfirmed: "Payment confirmed and booking completed!",
    status: "Status",
    actions: "Actions",
    cancelled: "Cancelled",
    rescheduled: "Rescheduled",
    cancelBooking: "Cancel booking",
    rescheduleBooking: "Reschedule booking",
    cancelBookingTitle: "Cancel this booking?",
    cancelBookingDesc: "The visitor will be notified by email. The slot will become available again.",
    confirmCancel: "Yes, cancel",
    rescheduleBookingTitle: "Reschedule booking",
    rescheduleBookingDesc: "Choose a new time for {{name}}'s booking. The visitor will be notified.",
    confirmReschedule: "Confirm reschedule",
    bookingCancelled: "Booking cancelled successfully",
    bookingRescheduled: "Booking rescheduled successfully",
    recurringAvailability: "Recurring availability",
    recurringDesc: "Set up automatic availability rules. Slots are generated every night for the upcoming days.",
    addRule: "Add rule",
    dayOfWeek: "Day of the week",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    advanceDays: "Days in advance",
    advanceDaysLabel: "{{days}} days ahead",
    ruleCreated: "Availability rule created!",
    generateNow: "Generate now",
    slotsGeneratedFromRules: "{{count}} slots generated from rules!",
  },
  blogPreview: {
    title: "Resources for creators who want to sell more",
    desc: "Guides, strategies and practical tips to monetize your social media.",
    viewAll: "Read all articles",
  },
  seoInternal: {
    title: "More useful guides",
    desc: "Discover our complete guides for creators and brands",
    descCreator: "Create your professional link-in-bio",
    descInstagram: "Optimize your Instagram bio link",
    descMonetize: "Strategies to earn with Instagram",
    descProducts: "Sell ebooks, courses and templates",
    descFree: "Start free with your link-in-bio",
    descBooking: "Take online bookings from your link in bio",
  },
  seoBooking: {
    metaTitle: "Online Bookings from Your Link in Bio | TuttiIMieiLink",
    metaDesc: "Take online bookings straight from your link in bio: calendar, upfront payment and automatic reminders. With Deeplink™ customers book without leaving social.",
    badge: "Online bookings · Included in your link in bio",
    title: "Online bookings ",
    titleHighlight: "straight from your link in bio",
    desc: "Your link in bio becomes a calendar: customers pick a day and time, pay upfront and get confirmation and reminder emails. No extra booking software needed.",
    cta: "Enable bookings free",
    viewPlans: "See plans",
    subCta: "No card required · Live in 2 minutes",
    whyTitle: "Everything you need to run online bookings",
    whyDesc: "Consultations, lessons, sessions, in-store appointments: set your availability and let customers book themselves.",
    features: [
      { title: "Calendar with real availability", desc: "Set days, hours and duration: the page only shows slots that are truly free." },
      { title: "Payment at booking time", desc: "Get paid by card, Apple Pay or Google Pay before the appointment and cut no-shows." },
      { title: "Automatic confirmations and reminders", desc: "Instant confirmation email and a reminder before the appointment, written for you." },
      { title: "Reschedule and cancel", desc: "Customers can move their time and you get an updated notification right away." },
      { title: "Booking analytics", desc: "See how many people visit the page, how many book and how much you earn." },
      { title: "Deeplink™ so you don't lose customers", desc: "Links open in the real browser instead of the in-app one, so payments and logins work first time." },
    ],
    howTitle: "Start taking bookings in 3 steps",
    steps: [
      { title: "Create your link in bio", desc: "Sign up free and pick your address: tuttimieilink.com/yourname." },
      { title: "Add your bookable service", desc: "Set name, duration, price and the time slots you're available." },
      { title: "Share the link on social", desc: "Put it in your Instagram, TikTok or YouTube bio and start receiving bookings." },
    ],
    deeplinkTitle: "Why Deeplink™ matters for bookings",
    deeplinkDesc: "When someone taps a link inside Instagram or TikTok, the page opens in the app's built-in browser: lost sessions, broken logins and payments that stall. TuttiIMieiLink's Deeplink™ sends visitors to the phone's real browser, so the calendar loads properly and the booking actually completes.",
    faqTitle: "Online bookings FAQ",
    faqs: [
      { q: "Can I take online bookings for free?", a: "Yes. Create your link in bio for free and enable a bookable service with no credit card. Paid plans add advanced analytics and unlimited services." },
      { q: "Do customers pay when they book?", a: "Your choice: charge upfront with card, Apple Pay or Google Pay, or let them book now and pay in person." },
      { q: "How do I avoid double bookings?", a: "Booked slots disappear from the public calendar immediately, so two people can't take the same time." },
      { q: "Does the customer get a reminder?", a: "Yes: a confirmation email right after booking and an automatic reminder before the appointment." },
      { q: "What is Deeplink™?", a: "It's the technology that opens your links in the phone's real browser instead of the social in-app browser, so payments, logins and bookings don't break." },
      { q: "Do I need separate booking software?", a: "No. Calendar, payments, emails and the public page are all inside TuttiIMieiLink, managed from the same link-in-bio dashboard." },
    ],
  },
  panels: {
    stripeAccount: "Your Stripe account",
    enterBothKeys: "Enter both keys",
    error: "Error",
    uploadError: "Upload error",
    tipButtonMessage: "Button message",
    tipDefaultLabel: "Buy me a coffee ☕",
    tipSaveError: "The Tip Jar was not saved. Please try again.",
    saveSettings: "Save settings",
    newAmount: "New amount (€)",
    editTier: "Edit tier",
    newTier: "New tier",
    tierNamePlaceholder: "Tier name (e.g. Bronze, Gold, Diamond)",
    tierDescPlaceholder: "Description (what this tier includes)",
    pricePerMonth: "Price (€/month)",
    cancel: "Cancel",
    editContent: "Edit content",
    newContent: "New content",
    contentTitlePlaceholder: "Content title",
    contentBodyPlaceholder: "Content (text, links, instructions...)",
    loading: "Loading...",
    deleteContentConfirm: "Delete this content?",
    searchContacts: "Search email or name...",
    all: "All",
    emailCol: "Email",
    nameCol: "Name",
    firstVisitCol: "First visit",
  },
};

export default en;
